// PsychometricTestLanding.js

import React, { useEffect, useState, useContext } from "react";
import GeneralNavbar from '../general/GeneralNavbar';
import { ThemeContext } from '../../contexts/ThemeContext';
import ErrorBoundary from '../general/ErrorBoundary';
import { useHistory } from 'react-router-dom';
import PsychometricTestMainNavbar from './PsychometricTestMainNavbar';
import PsychometricFooter from './PsychometricFooter';
import docAndPencilLogo from '../../assets/docAndPencilLogo.png';

const PsychometricTestLandingPage = () => {

    const { theme } = useContext(ThemeContext);
    const history = useHistory();
    const [selectedTestType, setSelectedTestType] = useState(null);

    const handleTestSelection = () => {
        if (selectedTestType === 'organization') {
            history.push('/psychometricOrganizationTestTakerPortal');
        } else if (selectedTestType === 'individual') {
            history.push('/psychometricIndividualTestTakerPortal');
        }
    };

  return (
    <div className="psychometric-landing" >
      <ErrorBoundary errorAt="At Psychometric Landing Page Navbar">
        <PsychometricTestMainNavbar />
      </ErrorBoundary>
      
      <header className="landing-header text-center">
        <h1 style={{ 
          color: '#70B646', 
          fontSize: 'clamp(2.5rem, 5vw, 4rem)',  // responsive larger font size
          ...theme.headingXXL
        }}>Psychometric Testing</h1>
        <p style={theme.paragraphHeading}>
        Welcome to Umang Wellness Psychometric Test 
        </p>
      </header>

      <div className="text-center" style={{ margin: 'clamp(1rem, 3vw, 2rem) 0' }}>
        <img 
          src={docAndPencilLogo}
          alt="Document and Pencil Logo"
          style={{
            maxWidth: 'clamp(150px, 20vw, 200px)', 
            height: 'auto',
            width: '100%'  
          }}
        />
      </div>

      {/* What This Site Is For Section */}
      <div className="container my-5">
        <div style={{
          ...theme.form,
          padding: 'clamp(1.5rem, 3vw, 2.5rem)',
          maxWidth: '800px',
          margin: '0 auto',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          backgroundColor: 'rgba(112, 182, 70, 0.05)'
        }}>
          <h2 style={{ 
            textAlign: 'center', 
            color: '#70B646',
            ...theme.headingBold,
            marginBottom: '1.5rem'
          }}>
            Discover Your Potential
          </h2>
          <p style={{
            ...theme.paragraphText,
            textAlign: 'center',
            marginBottom: '1.5rem',
            fontSize: 'clamp(1rem, 2vw, 1.1rem)',
            lineHeight: '1.6'
          }}>
            Our comprehensive psychometric testing platform helps you gain valuable insights into your 
            personality traits, cognitive abilities, and behavioral patterns. Whether you're an individual 
            seeking personal development or an organization enhancing your recruitment process, our 
            data-driven assessments provide meaningful guidance.
          </p>
          <div className="row text-center">
            <div className="col-md-6 mb-3">
              <h4 style={{ color: '#70B646', ...theme.headingBold }}>For Individuals</h4>
              <p style={theme.paragraphText}>
                Understand your strengths, interests, and career preferences through personalized testing
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h4 style={{ color: '#70B646', ...theme.headingBold }}>For Organizations</h4>
              <p style={theme.paragraphText}>
                Make informed hiring decisions and better understand your team dynamics
              </p>
            </div>
          </div>
          <div className="text-center mt-3">
            <p style={{
              ...theme.paragraphText,
              fontStyle: 'italic',
              color: '#666'
            }}>
              Note: Psychometric test accounts are separate from Umang Wellness accounts. 
              New users can sign up through Account Management above.
            </p>
          </div>
        </div>
      </div>

      {/* Test Taking Section */}
      <div className="container mb-5">
        <div style={{
          background: 'linear-gradient(135deg, rgba(112, 182, 70, 0.1) 0%, rgba(112, 182, 70, 0.05) 100%)',
          padding: 'clamp(2rem, 4vw, 3rem)',
          borderRadius: '15px',
          maxWidth: '600px',
          margin: '0 auto',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ 
            textAlign: 'center', 
            color: '#70B646',
            ...theme.headingBold,
            marginBottom: '0.5rem',
            fontSize: 'clamp(1.5rem, 3vw, 2rem)'
          }}>
            Take Test Below
          </h2>
          
          <p style={{
            ...theme.paragraphText,
            textAlign: 'center',
            marginBottom: '2rem',
            color: '#555',
            fontSize: 'clamp(0.9rem, 1.5vw, 1rem)'
          }}>
            Sign in below to take your psychometric assessment
          </p>

          <div style={{
            ...theme.form,
            backgroundColor: 'white',
            padding: 'clamp(1.5rem, 3vw, 2rem)',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)'
          }}>
            <h3 style={{ 
              textAlign: 'center', 
              color: '#70B646', 
              ...theme.headingBold,
              marginBottom: '1.5rem',
              fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)'
            }}>
              Test Taker Sign In
            </h3>
            
            <div className="mt-4">
              <div 
                className="form-check mb-4" 
                onClick={() => setSelectedTestType('organization')}
                style={{ 
                  padding: '1.5rem',
                  borderRadius: '8px',
                  border: selectedTestType === 'organization' ? '3px solid #70B646' : '2px solid #e9ecef',
                  backgroundColor: selectedTestType === 'organization' ? 'rgba(112, 182, 70, 0.1)' : 'transparent',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  transform: selectedTestType === 'organization' ? 'translateY(-2px)' : 'none',
                  boxShadow: selectedTestType === 'organization' ? '0 4px 12px rgba(112, 182, 70, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.05)'
                }}
              >
                {selectedTestType === 'organization' && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    color: '#70B646',
                    fontSize: '1.5rem',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
                <div>
                  <h4 style={{
                    ...theme.formBodyText,
                    fontWeight: 'bold',
                    fontSize: 'clamp(1.1rem, 1.8vw, 1.3rem)',
                    marginBottom: '0.5rem',
                    color: selectedTestType === 'organization' ? '#70B646' : '#333'
                  }}>
                    Organisation Test Taker
                  </h4>
                  <p style={{
                    margin: 0,
                    color: '#666',
                    fontSize: 'clamp(0.9rem, 1.3vw, 1rem)',
                    lineHeight: '1.4'
                  }}>
                    For candidates taking tests on behalf of an organization
                  </p>
                </div>
              </div>
              
              <div 
                className="form-check mb-4" 
                onClick={() => setSelectedTestType('individual')}
                style={{ 
                  padding: '1.5rem',
                  borderRadius: '8px',
                  border: selectedTestType === 'individual' ? '3px solid #70B646' : '2px solid #e9ecef',
                  backgroundColor: selectedTestType === 'individual' ? 'rgba(112, 182, 70, 0.1)' : 'transparent',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  transform: selectedTestType === 'individual' ? 'translateY(-2px)' : 'none',
                  boxShadow: selectedTestType === 'individual' ? '0 4px 12px rgba(112, 182, 70, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.05)'
                }}
              >
                {selectedTestType === 'individual' && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    color: '#70B646',
                    fontSize: '1.5rem',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
                <div>
                  <h4 style={{
                    ...theme.formBodyText,
                    fontWeight: 'bold',
                    fontSize: 'clamp(1.1rem, 1.8vw, 1.3rem)',
                    marginBottom: '0.5rem',
                    color: selectedTestType === 'individual' ? '#70B646' : '#333'
                  }}>
                    Individual Test Taker
                  </h4>
                  <p style={{
                    margin: 0,
                    color: '#666',
                    fontSize: 'clamp(0.9rem, 1.3vw, 1rem)',
                    lineHeight: '1.4'
                  }}>
                    For personal development and self-assessment
                  </p>
                </div>
              </div>
            </div>
            
            <div className="text-center mt-4">
              <button 
                className="btn btn-primary"
                onClick={handleTestSelection}
                disabled={!selectedTestType}
                style={{
                  ...theme.formSubmit,
                  padding: 'clamp(12px, 2vw, 16px) clamp(32px, 4vw, 48px)',
                  fontSize: 'clamp(1rem, 1.5vw, 1.2rem)',
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  minWidth: '200px',
                  backgroundColor: selectedTestType ? '#70B646' : '#ccc',
                  borderColor: selectedTestType ? '#70B646' : '#ccc',
                  transform: selectedTestType ? 'translateY(-2px)' : 'none',
                  boxShadow: selectedTestType ? '0 4px 12px rgba(112, 182, 70, 0.3)' : 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                Continue to Test →
              </button>
            </div>
            
            <div className="text-center mt-3">
              <p style={{
                ...theme.paragraphText,
                fontSize: 'clamp(0.8rem, 1.2vw, 0.9rem)',
                color: '#666',
                fontStyle: 'italic'
              }}>
                Don't have an account? Use Account Management above to sign up first.
              </p>
            </div>
          </div>
        </div>
      </div>

      <PsychometricFooter />
    </div>
  
  );
};

export default PsychometricTestLandingPage;
